class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.setupElements();
    this.attachEventListeners();
  }

  setupElements() {
    this.input = this.querySelector(".selected-selling-plan-id");
    this.planSelect = this.querySelector("select");
  }

  attachEventListeners() {
    if (this.planSelect) {
      this.planSelect.addEventListener(
        "change",
        this.handlePlanSelection.bind(this)
      );
    }
  }

  handlePlanSelection(event) {
    console.log("handlePlanSelection");
    const selectedOption = event.target.options[event.target.selectedIndex];
    const subscriptionId = selectedOption.getAttribute("data-selling-plan-id");

    // Update the hidden input value with the new selling plan ID
    this.updateSellingPlanId(subscriptionId);
  }

  updateSellingPlanId(sellingPlanId) {
    console.log("updateSellingPlanId", sellingPlanId);
    if (this.input) {
      this.input.value = sellingPlanId;
    }
  }
}

customElements.define("subscription-widget", SubscriptionWidget);
